import { Sidebar, ISidebarProps } from '../../../../Components/SideBar/Sidebar';
import { People, Person,GroupAdd ,Description} from '@material-ui/icons';
import { useIntl } from 'react-intl';
import { IListItemLinkProps } from '../../../../Components/ListItemLink/ListItemLink';
export const AdministrationSidebar = (props: ISidebarProps) => {
  const { formatMessage } = useIntl();
  const items:IListItemLinkProps[]=[
    // {
    //   to: '/administration/document',
    //   text: formatMessage({ id: 'component.sidebar.document', defaultMessage: 'Document' }),
    //   icon: <Description />,
    // },
    {
      to: '/administration/customers',
      text: formatMessage({ id: 'customer.header', defaultMessage: 'Customers' }),
      icon: <Person />,
    },
    {
      to: '/administration/users',
      text: formatMessage({ id: 'admin.users.header', defaultMessage: 'Users' }),
      icon: <People />,
    },
    // {
    //   to: '/administration/DocumentGroup',
    //   text: formatMessage({ id: 'document.sidebar.group', defaultMessage: 'Group' }),
    //   icon: <GroupAdd />,
    // },
  ] 
  return (
    <Sidebar
      title={formatMessage({ id: 'component.home.administration', defaultMessage: 'Administration' })}
      items={items}
      sidebarOpen={props.sidebarOpen}
      handleSidebarToggle={props.handleSidebarToggle}
    />
  );
};
